var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _line, _line2, _line3, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _polygon, _ellipse, _path38, _path39, _path40, _path41, _path42, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDairy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b64dd61c-37aa-4aae-978c-fa4a6cf20da0",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "fd2c1ccc-b054-4c15-873c-f604781a59f2",
    "data-name": "freepik--background-simple--inject-6"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M676.41,119.61c-46.1-48-118.15-73.63-186.32-79.92A591.3,591.3,0,0,0,430,37.35c-197.91,1.94-255.88,80.21-243.19,117.9s48.37,60.89-3.12,113.06S74.13,398.73,103.62,477,255.21,616.17,432.08,606.5s291.61-10.63,328.46-83.07-43.69-122.19-55-184.31c-7-38.51,11-77.34,12.31-115.74C719.24,181.85,702.92,147.23,676.41,119.61Z",
    fill: "#7d00f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M676.41,119.61c-46.1-48-118.15-73.63-186.32-79.92A591.3,591.3,0,0,0,430,37.35c-197.91,1.94-255.88,80.21-243.19,117.9s48.37,60.89-3.12,113.06S74.13,398.73,103.62,477,255.21,616.17,432.08,606.5s291.61-10.63,328.46-83.07-43.69-122.19-55-184.31c-7-38.51,11-77.34,12.31-115.74C719.24,181.85,702.92,147.23,676.41,119.61Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aca1d71d-647c-48de-bd8b-e807df6de6c6",
    "data-name": "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.84,481c9.11-4.7,19.83-5.32,30-3.64,5.45.9,11.1,2.52,14.79,6.6s4.4,11.25.15,14.77c-2.52,2.08-6,2.4-9.32,2.36-7.92-.1-16.7-1.49-23,3.28-3.61,2.73-6,7.22-10.32,8.56s-9-1.17-11.21-5A17.41,17.41,0,0,1,668.62,495,19.64,19.64,0,0,1,678.84,481Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658,440.68c5.57,7.95,16.35,5.32,21.41.46s7.14-11.89,9.07-18.6c4.41-15.33,8.86-31.41,5.58-47a26.07,26.07,0,0,0-6-12.78c-3.27-3.47-8.32-5.52-12.93-4.31-5.46,1.44-8.85,6.81-11.3,11.87a112,112,0,0,0-11.07,48.09c0,7.75.89,15.88,5.25,22.28",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.69,452.1c6-7.18,7.19-17.65,4.51-26.63s-8.78-16.64-15.78-22.88a84.68,84.68,0,0,0-28.24-16.66,30.15,30.15,0,0,0-12.7-2.16c-4.3.41-8.65,2.62-10.65,6.45-3,5.67-.13,12.55,2.95,18.15a216.5,216.5,0,0,0,18.55,28.25c5.56,7.17,11.94,14.24,20.44,17.48s17.28,2.85,21.81-3",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.61,560.63a18.47,18.47,0,0,0,.51-3.61c.24-2.63.57-5.93,1-9.87a141.41,141.41,0,0,1,2.22-14.46,110.77,110.77,0,0,1,5.26-17.07,62.51,62.51,0,0,1,8.71-15.44,32.65,32.65,0,0,1,11-9.17,31,31,0,0,1,9.28-2.89,16.81,16.81,0,0,0,3.6-.52,15.91,15.91,0,0,0-3.65,0,27.83,27.83,0,0,0-9.69,2.52,32.39,32.39,0,0,0-11.62,9.24,62,62,0,0,0-9,15.75,105.41,105.41,0,0,0-5.22,17.36A124.51,124.51,0,0,0,658,547.11c-.31,4.2-.44,7.58-.49,9.93A16,16,0,0,0,657.61,560.63Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.29,553a7.9,7.9,0,0,0,.1-1.68v-4.78c0-4.17,0-10.2.2-17.62.37-14.88,1.65-30.88,4.09-53.45,2.34-21.22,5.45-45.91,8.8-62,.71-3.65,1.43-6.94,2.1-9.81s1.2-5.37,1.73-7.39.82-3.43,1.12-4.66a7.14,7.14,0,0,0,.29-1.65,8,8,0,0,0-.58,1.57l-1.36,4.59c-.61,2-1.24,4.47-2,7.35s-1.55,6.13-2.33,9.78a542.55,542.55,0,0,0-9.25,57.49c-2.48,22.61-3.6,43.2-3.7,58.11-.08,7.45.07,13.49.26,17.72.12,1.93.22,3.53.3,4.78A6.75,6.75,0,0,0,658.29,553Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.39,513.33a32.1,32.1,0,0,0,0-5c-.18-3.22-.63-7.88-1.53-13.63a180.27,180.27,0,0,0-4.41-19.77,162.38,162.38,0,0,0-8.27-23.39C637.36,435.27,628,422,619.9,413.73a61.15,61.15,0,0,0-5.72-5.31c-.87-.74-1.65-1.48-2.44-2.07l-2.21-1.52a31.68,31.68,0,0,0-4.22-2.73c-.23.33,6,4,13.83,12.33a131.24,131.24,0,0,1,23.67,37.67,184.75,184.75,0,0,1,8.31,23.17,201.18,201.18,0,0,1,4.71,19.57c1.09,5.62,1.62,10.24,2,13.43A30.74,30.74,0,0,0,658.39,513.33Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "620 583.38 623.98 637.89 694.01 637.89 697.99 583.38 620 583.38",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.24,
    y: 561.89,
    width: 93.12,
    height: 21.49,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "613.24 635.81 613.24 641.76 617.62 641.76 704.82 641.76 704.82 635.81 613.24 635.81",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "621.91 652.24 617.62 641.76 701.48 641.76 696.48 652.24 621.91 652.24",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.69,601.2a2,2,0,0,1-.32.5l-1,1.36-4.09,5.22-.18.23-.17-.24c-2.58-3.54-6-8.29-10-13.86h.57c-3,4.22-6.3,8.93-9.87,14l-.3.43-.35-.41-11.71-13.92h.68l-.64.8L648.77,608.4l-.36.44-.31-.46-9.83-13.94h.58L626.69,608.3l-.22.24-.16-.27-3.8-6.41-1-1.7a2.41,2.41,0,0,1-.3-.6,3.93,3.93,0,0,1,.41.53l1.07,1.65,4,6.27h-.38l11.93-14,.3-.36.28.38,10,13.92h-.67l10.44-13.14.64-.8.33-.43.35.41,11.67,14h-.66l10-13.9.3-.41.29.41,9.8,14h-.36l4.25-5.09,1.14-1.36A2.11,2.11,0,0,1,696.69,601.2Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699,583c0,.24-17.55.43-39.19.43s-39.19-.19-39.19-.43,17.55-.44,39.19-.44S699,582.79,699,583Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.51,642.35c0,.25-19.07.44-42.6.44s-42.58-.19-42.58-.44,19.08-.44,42.58-.44S702.51,642.11,702.51,642.35Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.14,
    y: 238.89,
    width: 320.04,
    height: 10.14,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.19,
    y: 243.96,
    width: 16.2,
    height: 32.09,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.33,
    y: 238.89,
    width: 16.2,
    height: 37.16,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.84 170.81 179.32 239.66 240.19 239.66 254.33 171.8 168.84 170.81",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.81,215c0,.2-15.6.35-34.83.35s-34.85-.15-34.85-.35,15.61-.36,34.85-.36S245.81,214.74,245.81,215Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,211.55c0,.19-15.7.36-35.06.36s-35.08-.17-35.08-.36,15.7-.35,35.08-.35S246,211.35,246,211.55Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.93,207.72c0,.21-15.71.36-35.07.36s-35.08-.15-35.08-.36,15.7-.35,35.08-.35S245.93,207.53,245.93,207.72Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.31,235.73a57.09,57.09,0,0,1-1.82-8.67,55.39,55.39,0,0,1-1.16-8.79,58.2,58.2,0,0,1,1.87,8.67A56.34,56.34,0,0,1,186.31,235.73Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,235a63,63,0,0,1-.75-8.46,68.76,68.76,0,0,1-.41-8.49,39.38,39.38,0,0,1,1.11,8.44A40.35,40.35,0,0,1,190.46,235Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,235a42.43,42.43,0,0,1-1.58-8.67,42.5,42.5,0,0,1-.46-8.8,80.07,80.07,0,0,1,1.17,8.72A75.58,75.58,0,0,1,198,235Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.31,235.43a42.88,42.88,0,0,1-.85-8.82,42.15,42.15,0,0,1,.27-8.84,78.87,78.87,0,0,1,.44,8.83A81.27,81.27,0,0,1,203.31,235.43Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.68,235a47.76,47.76,0,0,1-.64-8.36,51.22,51.22,0,0,1,0-8.4,47.94,47.94,0,0,1,.64,8.37A49,49,0,0,1,212.68,235Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.54,235.43a52.19,52.19,0,0,1-.3-8.66,51,51,0,0,1,.43-8.64,53.33,53.33,0,0,1,.29,8.66A54.31,54.31,0,0,1,219.54,235.43Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,234.45a58.18,58.18,0,0,1,.52-9,57.6,57.6,0,0,1,1.23-9,55.83,55.83,0,0,1-.52,9A56.7,56.7,0,0,1,226,234.45Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.24,233.55a30.32,30.32,0,0,1,1-7.7,31,31,0,0,1,2.26-7.42A69.28,69.28,0,0,1,236,226,74.77,74.77,0,0,1,234.24,233.55Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,34.94a1.93,1.93,0,0,1,0,.34c-.09.26-.17.58-.29,1L226.92,40c-.52,1.61-1.14,3.58-1.78,5.89s-1.47,4.92-2.2,7.85-1.61,6.12-2.37,9.54-1.62,7.29-2.41,11.14c-1.46,7.85-2.79,16.59-3.69,25.69S213.1,118,213.1,126c0,4,0,7.78.11,11.34s.25,6.81.43,9.87.42,5.73.6,8.17.39,4.46.58,6.14.31,2.93.41,3.87a3.71,3.71,0,0,0,.08,1c.08.28,0,.36,0,.36a1.4,1.4,0,0,1-.08-.34,8.42,8.42,0,0,0-.16-1c-.13-.94-.3-2.23-.54-3.87s-.49-3.72-.7-6.12-.55-5.11-.71-8.17-.42-6.33-.52-9.88-.15-7.36-.18-11.35c.08-8,.48-16.81,1.37-26s2.28-17.9,3.78-25.75c.82-3.92,1.56-7.66,2.43-11.1s1.65-6.67,2.45-9.54,1.61-5.53,2.31-7.84,1.36-4.26,1.9-5.86l1.28-3.68c.15-.38.26-.69.36-.95A.72.72,0,0,0,228.37,34.94Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.38,77.58a22.68,22.68,0,0,1,9.54-12c1.5-.93,3.41-1.69,5-.92,2.13,1,2.29,4.09,1.67,6.29a16.62,16.62,0,0,1-6.9,9.39A14.07,14.07,0,0,1,216.36,83",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.69,106.36c1.57-5.94,6.31-14.39,11.23-18.07a7.8,7.8,0,0,1,2.56-1.36,3,3,0,0,1,2.73.6,4.11,4.11,0,0,1,.61,3.94,24,24,0,0,1-17.72,17.88",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.67,131.71A34.61,34.61,0,0,1,224,117.46a5.34,5.34,0,0,1,4-1.37c2.15.4,3.13,3,2.94,5.19-.39,4.49-3.81,8.09-7.36,10.91a45.4,45.4,0,0,1-10.48,5.45",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.24,149.93a33.37,33.37,0,0,1,9.65-11,6.9,6.9,0,0,1,2.89-1.37,3,3,0,0,1,2.85,1.08c1,1.36,0,3.34-1,4.71a27.49,27.49,0,0,1-13.76,10.09",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.76,142.53A106.44,106.44,0,0,0,199,128.48a3.12,3.12,0,0,0-2.72-1,2.07,2.07,0,0,0-1.27,1.85,5.58,5.58,0,0,0,.53,2.31,26.76,26.76,0,0,0,17.72,15",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,118.82l-10.83-13.21a13,13,0,0,0-3.52-3.34,3.94,3.94,0,0,0-5.5.78,4,4,0,0,0-.61,3.53,11.68,11.68,0,0,0,2.12,4.33,32.07,32.07,0,0,0,7.9,8.4c3.18,2.18,6.06,3.61,9.89,3",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.71,92.12a37.89,37.89,0,0,0-10.9-16.35A6.36,6.36,0,0,0,201,74.12c-2.16-.42-4.26,1.36-5,3.49a9,9,0,0,0,1,7.17,19.07,19.07,0,0,0,5.1,5.45,43.53,43.53,0,0,0,12,6.51",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.05,68.33c-1.05-7.66-5.05-14-9.67-20.22-1-1.37-2.33-2.73-3.93-2.46a3.18,3.18,0,0,0-2.27,2,7.23,7.23,0,0,0-.43,3,23.68,23.68,0,0,0,15.36,21.14",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.07,56.17a61.47,61.47,0,0,1-.39-11.82,21.14,21.14,0,0,1,3.92-11,9.25,9.25,0,0,1,3.94-3.14,5,5,0,0,1,4.82.64,5.24,5.24,0,0,1,1.66,4.3,13.49,13.49,0,0,1-1.22,4.53c-2.89,6.94-7.7,14.64-12.73,16.57",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.87,65.3a5.24,5.24,0,0,1,0,1V73.4c0,1.67,0,3.65.2,5.8.19,4.31.61,9.43,1.27,15.09s1.66,11.85,3,18.29,3,12.49,4.6,18,3.35,10.3,4.91,14.32c.73,2,1.5,3.82,2.14,5.45s1.21,2.94,1.7,4.09l1.09,2.56a6.26,6.26,0,0,1,.34.91,4.75,4.75,0,0,1-.48-.85c-.3-.65-.7-1.48-1.19-2.51s-1.16-2.43-1.83-4-1.47-3.36-2.25-5.45c-1.62-4-3.35-8.86-5.07-14.31s-3.13-11.5-4.5-18-2.29-12.67-3-18.35-1-10.82-1.12-15.14c-.11-2.17-.08-4.09-.1-5.84s0-3.19,0-4.4a20,20,0,0,1,.1-2.72A8.8,8.8,0,0,1,174.87,65.3Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.57,96.7a16.13,16.13,0,0,1,3.83-10.18,3.89,3.89,0,0,1,3.21-1.7c1.67.24,2.43,2.23,2.48,3.92a11.89,11.89,0,0,1-2.72,7.88,10,10,0,0,1-6.47,4",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.25,117.09c-.21-4.38,1.2-11.15,3.76-14.72a5.3,5.3,0,0,1,1.44-1.47,2.13,2.13,0,0,1,2-.19,3,3,0,0,1,1.27,2.53,17.07,17.07,0,0,1-8.18,16",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,134.58a25,25,0,0,1,4.65-12.15,3.92,3.92,0,0,1,2.4-1.81c1.54-.19,2.73,1.36,3.12,2.9.7,3.15-.87,6.32-2.72,9a33,33,0,0,1-6,5.93",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.32,146.85a23.94,23.94,0,0,1,4.2-9.54,5.1,5.1,0,0,1,1.69-1.51,2.14,2.14,0,0,1,2.17.12c1,.76.75,2.26.34,3.42a19.68,19.68,0,0,1-7.2,9.84",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.4,141.9A77.18,77.18,0,0,0,175,135.31a2.26,2.26,0,0,0-2.1-.11,1.42,1.42,0,0,0-.46,1.52,3.7,3.7,0,0,0,.85,1.46,19,19,0,0,0,15.33,6.35",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.59,125.67,172.37,119a9,9,0,0,0-3.1-1.51,3.22,3.22,0,0,0-3.17,1,3.16,3.16,0,0,0,0,3.3,8.28,8.28,0,0,0,2.37,2.49,23.23,23.23,0,0,0,7.19,4.09c2.64.8,4.92,1.14,7.4,0",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.88,107.18a27,27,0,0,0-10.9-8.8,4.69,4.69,0,0,0-2.29-.52,3.42,3.42,0,0,0-2.63,3.45,6.32,6.32,0,0,0,2.16,4.66,13.56,13.56,0,0,0,4.64,2.57,31,31,0,0,0,9.54,1.83",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7,90c-2.36-5-6.45-8.47-10.9-11.69a3.38,3.38,0,0,0-3.22-.82,2.21,2.21,0,0,0-1.12,1.81,5.25,5.25,0,0,0,.37,2.18,16.88,16.88,0,0,0,15,11.08",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.15,81.11a44.93,44.93,0,0,1-2.82-8,15.11,15.11,0,0,1,.3-8.35,6.63,6.63,0,0,1,2-3,3.59,3.59,0,0,1,3.44-.6,3.76,3.76,0,0,1,2,2.52,9.49,9.49,0,0,1,.15,3.36c-.46,5.35-2.1,11.62-5.1,14",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.83,64.64a3.86,3.86,0,0,1,.08,1,26,26,0,0,0,.11,2.73,32,32,0,0,1,0,4.4c-.08,1.68,0,3.67-.11,5.83-.12,4.32-.49,9.46-1.11,15.14s-1.61,11.9-3,18.36-3,12.54-4.67,18-3.45,10.3-5.07,14.31c-.76,2-1.58,3.8-2.25,5.45s-1.29,2.92-1.81,4-.91,1.86-1.21,2.5a6.48,6.48,0,0,1-.47.86,5,5,0,0,1,.33-.91c.29-.65.64-1.51,1.09-2.56s1.08-2.46,1.7-4.09,1.37-3.39,2.14-5.45c1.57-4.09,3.25-8.89,4.92-14.32s3.26-11.46,4.62-17.9,2.31-12.63,3-18.28,1.08-10.78,1.27-15.09c.13-2.15.15-4.09.2-5.8s0-3.19,0-4.41V65.66A5,5,0,0,1,251.83,64.64Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13,96a16.13,16.13,0,0,0-3.87-10.18,3.88,3.88,0,0,0-3.18-1.69c-1.67.25-2.42,2.24-2.49,3.93A11.92,11.92,0,0,0,243.32,96a10,10,0,0,0,6.48,4",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.45,116.42c.22-4.37-1.2-11.15-3.76-14.72a5,5,0,0,0-1.45-1.47,2.13,2.13,0,0,0-2-.19A3,3,0,0,0,238,102.6a17.1,17.1,0,0,0,8.18,16",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.72,133.9a24.85,24.85,0,0,0-4.65-12.15,3.9,3.9,0,0,0-2.39-1.81c-1.54-.2-2.73,1.36-3.11,2.9-.7,3.15.86,6.32,2.72,9a33,33,0,0,0,6,5.93",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.39,146.18a24,24,0,0,0-4.21-9.54,4.89,4.89,0,0,0-1.69-1.51,2.14,2.14,0,0,0-2.17.12c-.95.77-.75,2.26-.34,3.42a19.6,19.6,0,0,0,7.19,9.84",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3,141.24a77.52,77.52,0,0,1,12.41-6.66,2.29,2.29,0,0,1,2.1-.1,1.42,1.42,0,0,1,.46,1.52,3.61,3.61,0,0,1-.86,1.46,19,19,0,0,1-15.3,6.35",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.11,125.05l10.22-6.67a9.41,9.41,0,0,1,3.1-1.51,3.19,3.19,0,0,1,3.16.95,3.14,3.14,0,0,1,.07,3.3,8.19,8.19,0,0,1-2.37,2.5,23.15,23.15,0,0,1-7.18,4.08c-2.63.81-4.91,1.15-7.39,0",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.82,106.51a27.12,27.12,0,0,1,10.9-8.8,4.86,4.86,0,0,1,2.31-.52,3.44,3.44,0,0,1,2.63,3.45,6.38,6.38,0,0,1-2.23,4.67,13.57,13.57,0,0,1-4.62,2.58,31.33,31.33,0,0,1-9.53,1.83",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,89.37c2.36-5,6.45-8.46,10.9-11.69a3.36,3.36,0,0,1,3.21-.82,2.26,2.26,0,0,1,1.14,1.85,5.39,5.39,0,0,1-.37,2.18,16.88,16.88,0,0,1-15,11.08",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.55,80.44a44.93,44.93,0,0,0,2.82-8,15.2,15.2,0,0,0-.3-8.35,6.71,6.71,0,0,0-2-3,3.57,3.57,0,0,0-3.42-.6,3.76,3.76,0,0,0-2,2.54,9.43,9.43,0,0,0-.15,3.35c.48,5.36,2.1,11.63,5.1,14",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.87,157.18V170a5.07,5.07,0,0,0,5.06,5.07h88.15a5.07,5.07,0,0,0,5.07-5.07h0V157.14Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.5 175.13 170.23 179.23 251.57 185.02 253.63 175.13 169.5 175.13",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.9,148s-14.63,11.12-.62,25.9a1.24,1.24,0,0,0,.93.38l127.66-.74s10.9-12.26,1.85-26.31Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.65,159.6c0,.15-15.89.26-35.43.26s-35.5-.11-35.5-.26,15.89-.25,35.5-.25S399.65,159.47,399.65,159.6Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.79,164.22c0,.15-7.47.26-16.69.26s-16.69-.11-16.69-.26,7.48-.25,16.69-.25S379.79,164.09,379.79,164.22Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.7,173.07c-.08,0,.29-1.47.68-3.83a53.18,53.18,0,0,0-.17-18.62c-.45-2.35-.83-3.8-.75-3.81a4.82,4.82,0,0,1,.37,1c.21.64.46,1.58.73,2.73a44.93,44.93,0,0,1,.18,18.76c-.25,1.17-.48,2.13-.68,2.73A4,4,0,0,1,412.7,173.07Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.23,147a4,4,0,0,1,.57.93,12.12,12.12,0,0,1,.57,1.14c.19.45.45,1,.64,1.55a26.33,26.33,0,0,1,1.23,4.24,32.16,32.16,0,0,1,.54,5.45,29.28,29.28,0,0,1-.46,5.37,28.6,28.6,0,0,1-1.14,4.27c-.19.6-.44,1.1-.63,1.56a10.81,10.81,0,0,1-.55,1.16,4.38,4.38,0,0,1-.55.93c-.1,0,.62-1.36,1.36-3.77a29.63,29.63,0,0,0,1-4.23,32.34,32.34,0,0,0,.41-5.29,31.16,31.16,0,0,0-.5-5.28,28.91,28.91,0,0,0-1.09-4.21C422.88,148.4,422.15,147,422.23,147Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,173.23a3.79,3.79,0,0,1-.6-.84,11.24,11.24,0,0,1-.6-1.07,16,16,0,0,1-.68-1.47,21.67,21.67,0,0,1-1.24-4.09,24.57,24.57,0,0,1-.49-5.13,23.91,23.91,0,0,1,.62-5.13,22.38,22.38,0,0,1,1.37-4c.23-.56.5-1,.72-1.46s.4-.71.62-1.05a4.18,4.18,0,0,1,.62-.83c.09,0-.72,1.28-1.62,3.48a24.76,24.76,0,0,0-1.23,3.95,26.55,26.55,0,0,0-.57,5,27.52,27.52,0,0,0,.43,5,26.25,26.25,0,0,0,1.12,4C319.4,171.92,320.12,173.19,320,173.23Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.25,176.35a6.29,6.29,0,0,1-.66-1c-.24-.39-.46-.79-.67-1.2s-.53-1.09-.76-1.65a27.63,27.63,0,0,1-1.47-4.51,31,31,0,0,1-.71-5.75,30.4,30.4,0,0,1,.46-5.8,25.91,25.91,0,0,1,1.26-4.56c.22-.64.49-1.19.69-1.68A10.74,10.74,0,0,1,305,149a5.43,5.43,0,0,1,.61-1c.09,0-.72,1.51-1.58,4.09a27.93,27.93,0,0,0-1.13,4.52,34,34,0,0,0-.42,5.7,36.09,36.09,0,0,0,.66,5.67,32,32,0,0,0,1.37,4.47C305.46,174.88,306.34,176.3,306.25,176.35Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.18,212.36v24.43H375.91V212.36Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.52,224.8v.64a14,14,0,0,0,14.06,13.11H425.39v-1.76H392a12.26,12.26,0,0,1-12.26-12.27h0A12.26,12.26,0,0,1,392,212.26h33.43v-2.6l-140.82.47a14.09,14.09,0,0,0-14.07,14.1C270.5,224.42,270.51,224.61,270.52,224.8Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.18,224.89c0,.15-9.71.26-21.71.26s-21.7-.11-21.7-.26,9.71-.26,21.7-.26S423.18,224.76,423.18,224.89Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,230.4c0,.15-9.2.26-20.54.26s-20.55-.11-20.55-.26,9.2-.26,20.55-.26S422.5,230.26,422.5,230.4Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.18,235.43c0,.15-8.27.26-18.46.26s-18.47-.11-18.47-.26,8.26-.25,18.47-.25S423.18,235.29,423.18,235.43Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.18,220c0,.15-9.54.26-21.26.26s-21.27-.11-21.27-.26,9.54-.26,21.27-.26S423.18,219.81,423.18,220Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,215c0,.15-8.48.25-18.93.25s-18.93-.1-18.93-.25,8.48-.26,18.93-.26S422.5,214.86,422.5,215Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.56,210.64a33.84,33.84,0,0,0-3,3.56,18.09,18.09,0,0,0,.24,20.94,30.9,30.9,0,0,0,3.08,3.48,4.71,4.71,0,0,1-1-.75,15.18,15.18,0,0,1-2.34-2.53,17.7,17.7,0,0,1-.26-21.35,16,16,0,0,1,2.29-2.57A5.32,5.32,0,0,1,287.56,210.64Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.81,210.12a32.52,32.52,0,0,0-2.93,3.5,18.08,18.08,0,0,0,.24,20.93,30.91,30.91,0,0,0,3.07,3.49,4.35,4.35,0,0,1-1-.75,15.23,15.23,0,0,1-2.36-2.52,17.81,17.81,0,0,1-.24-21.35,15.17,15.17,0,0,1,2.29-2.58A5.09,5.09,0,0,1,282.81,210.12Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.47,210.64a33,33,0,0,0-3,3.56,18.14,18.14,0,0,0,.25,20.94,32.75,32.75,0,0,0,3.08,3.48,4.8,4.8,0,0,1-1-.75,15.64,15.64,0,0,1-2.35-2.53,17.84,17.84,0,0,1-.26-21.35,16.13,16.13,0,0,1,2.31-2.57A4.37,4.37,0,0,1,378.47,210.64Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.7,210.12a34.89,34.89,0,0,0-3,3.56,18.08,18.08,0,0,0,.24,20.93,29.6,29.6,0,0,0,3.08,3.54,4.4,4.4,0,0,1-1-.75,15.11,15.11,0,0,1-2.34-2.52,17.7,17.7,0,0,1-.26-21.35,15.17,15.17,0,0,1,2.29-2.58A4.64,4.64,0,0,1,373.7,210.12Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.59,228.23c0-3.31,0-6.63-.14-9.93a6.93,6.93,0,0,0-.34-2.56,2.44,2.44,0,0,0-1.89-1.6c-1.24-.54-3.18.49-4.09,1.92a9.35,9.35,0,0,0-1,4.87,71,71,0,0,0,.38,7.85,9.14,9.14,0,0,0,.93,3.59,3.37,3.37,0,0,0,3,1.83,3.41,3.41,0,0,0,2.66-2.32A10,10,0,0,0,303.59,228.23Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,225.37c0,.15-10.16.26-22.72.26s-22.74-.11-22.74-.26,10.18-.26,22.74-.26S358.26,225.23,358.26,225.37Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.16 209.67 293.9 186.5 306.5 186.5 306.94 209.67 294.16 209.67",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.77,190.63a33.63,33.63,0,0,1-5.85.26,32.87,32.87,0,0,1-5.86-.26,31.91,31.91,0,0,1,5.86-.25A31.77,31.77,0,0,1,305.77,190.63Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.77,194.2a33.63,33.63,0,0,1-5.85.26,32.87,32.87,0,0,1-5.86-.26,68.69,68.69,0,0,1,11.71,0Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.77,197.77a31.77,31.77,0,0,1-5.85.26,31.92,31.92,0,0,1-5.86-.26,68.69,68.69,0,0,1,11.71,0Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.77,201.36a34.63,34.63,0,0,1-5.85.24,34.84,34.84,0,0,1-5.86-.24,66.06,66.06,0,0,1,11.71,0Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.77,204.93a66.06,66.06,0,0,1-11.71,0,66.06,66.06,0,0,1,11.71,0Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.23,185.89H432.94c1.72,7.67,1.47,16.11,0,25H293.83v-1.7h8.49a4.08,4.08,0,0,0,4-4V191.36a4,4,0,0,0-4-4h-9.11Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.21,198.43h2.33a.53.53,0,0,1,.25,0,.51.51,0,0,1,.24.45.38.38,0,0,1,0,.15,5.5,5.5,0,0,1-.16.58,6.4,6.4,0,0,1-1.46,2.65,2.72,2.72,0,0,1-2,1h-.28a2.22,2.22,0,0,1-1.58-1.14,5.15,5.15,0,0,1-.71-2.81,7.62,7.62,0,0,1,.28-2,6.55,6.55,0,0,1,1.37-2.72,2.8,2.8,0,0,1,2.1-1.12,1.93,1.93,0,0,1,.88.21,2.82,2.82,0,0,1,1.36,1.7.45.45,0,0,1,0,.23.44.44,0,0,1-.06.25.49.49,0,0,1-.44.24h-.15a.51.51,0,0,1-.33-.31h0a2.85,2.85,0,0,0-.28-.55,1.37,1.37,0,0,0-1.12-.66,1.17,1.17,0,0,0-.76.28,4,4,0,0,0-1.29,1.83,7,7,0,0,0-.54,2.63,4.74,4.74,0,0,0,.4,2.06,1.36,1.36,0,0,0,1.21.91,1.67,1.67,0,0,0,1.13-.67,6.16,6.16,0,0,0,1.2-2.17h-1.68a.57.57,0,0,1-.56-.55.49.49,0,0,1,0-.17A.55.55,0,0,1,326.21,198.43Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.2,193.88V194c.09.34.65,3.23,1.64,8.67a.24.24,0,0,1,0,.12.57.57,0,0,1,0,.26.47.47,0,0,1-.42.24h-.08A.42.42,0,0,1,335,203l-.56-2.87h-2.88L330.16,203v.1a.52.52,0,0,1-.43.24.46.46,0,0,1-.28-.08.47.47,0,0,1-.23-.41.38.38,0,0,1,0-.15c.08-.2.22-.51.42-.95q3-6.59,3.6-7.77a.56.56,0,0,1,.49-.34A.53.53,0,0,1,334.2,193.88Zm-.63,1.93L332,199.08h2.19Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,203.33h-4.21a.38.38,0,0,1-.26-.08.74.74,0,0,1-.25-.52h0c0-.16.4-3,1.16-8.61v-.19a.47.47,0,0,1,.45-.3.45.45,0,0,1,.23,0,.46.46,0,0,1,.27.44,19.13,19.13,0,0,1-.28,2.37c-.48,3.68-.74,5.63-.77,5.82h3.59a.61.61,0,0,1,.27,0,.45.45,0,0,1,.31.47.49.49,0,0,1,0,.17A.58.58,0,0,1,342,203.33Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.74,193.88a.43.43,0,0,1,0,.16c.11.35.66,3.23,1.65,8.67a.24.24,0,0,1,0,.12.57.57,0,0,1,0,.26.49.49,0,0,1-.42.24h-.08a.46.46,0,0,1-.39-.34l-.55-2.87h-2.87L343.72,203a.17.17,0,0,1,0,.1.52.52,0,0,1-.43.24.54.54,0,0,1-.28-.08.47.47,0,0,1-.22-.41.38.38,0,0,1,0-.15c.09-.2.24-.51.43-.95,2-4.39,3.22-7,3.61-7.77a.5.5,0,0,1,.91-.09Zm-.63,1.93-1.55,3.27h2.19Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.45,198.85l.76,2.1c.44,1.2.65,1.84.65,1.91a.41.41,0,0,1-.08.24.46.46,0,0,1-.42.23.43.43,0,0,1-.42-.32l-.07-.22c-.23-.53-.61-1.51-1.13-3l-2.39,3.26a.53.53,0,0,1-.45.25.39.39,0,0,1-.26,0,.44.44,0,0,1-.23-.42v-.19a1.19,1.19,0,0,1,.26-.41c.79-1,1.68-2.26,2.64-3.69-.1-.27-.2-.55-.28-.79-.91-2.4-1.36-3.64-1.36-3.72a.58.58,0,0,1,.06-.26.44.44,0,0,1,.41-.25.51.51,0,0,1,.47.28l1.36,3.79,2.81-3.82a.56.56,0,0,1,.45-.25.45.45,0,0,1,.23,0,.47.47,0,0,1,.24.45.49.49,0,0,1,0,.24Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.87,193.66a.45.45,0,0,1,.23,0,.51.51,0,0,1,.27.44c-.69,5.45-1.08,8.39-1.14,8.81a5.51,5.51,0,0,1-.9,2.31,3.27,3.27,0,0,1-4.09,1,3,3,0,0,1-1.48-1.37.49.49,0,0,1,0-.24.38.38,0,0,1,.07-.25.46.46,0,0,1,.8,0,2.72,2.72,0,0,0,2.17,1.23,2.12,2.12,0,0,0,1.66-.84,4.63,4.63,0,0,0,.93-2.65,2.78,2.78,0,0,1-.62.66,2.57,2.57,0,0,1-1.51.49H361a2.29,2.29,0,0,1-1.59-1.15,5.29,5.29,0,0,1-.7-2.81c0-.52,0-1.05.07-1.58.08-.85.26-2,.56-3.62V194a.44.44,0,0,1,.45-.34.55.55,0,0,1,.25.07.44.44,0,0,1,.24.39c0,.26-.08.9-.23,1.92a29.25,29.25,0,0,0-.33,2.95,6.08,6.08,0,0,0,.37,2.27c.3.7.71,1,1.25,1h.17a2.3,2.3,0,0,0,1.26-1,6.16,6.16,0,0,0,1-2.32l.64-4.79a.57.57,0,0,1,.07-.22A.46.46,0,0,1,364.87,193.66Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.69,211.25c-.15,0-.26-5.75-.26-12.83s.11-12.84.26-12.84.26,5.74.26,12.84S427.83,211.25,427.69,211.25Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.37,211.25c-.15,0-.26-5.75-.26-12.83s.11-12.84.26-12.84.25,5.74.25,12.84S313.51,211.25,313.37,211.25Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.13,211.25c-.13,0-.24-5.75-.24-12.83s.11-12.84.24-12.84.26,5.74.26,12.84S430.28,211.25,430.13,211.25Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.07,211.25c-.14,0-.24-5.75-.24-12.83s.1-12.84.24-12.84.26,5.74.26,12.84S311.22,211.25,311.07,211.25Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.82,189.8h0l14.77,11.91.12.11h-.16l-2,.52-12.47,3.27h0l-11.29-4.78-3.2-1.37-.85-.36-.22-.1h0l.21.1.85.34,3.22,1.36,11.32,4.73h0l12.45-3.29,2-.51v.15l-14.73-11.95h0",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.22 199.82 408.03 200.57 409.11 200.34 408.64 201.34 409.19 202.3 408.1 202.15 407.36 202.98 407.16 201.89 406.13 201.44 407.12 200.92 407.22 199.82",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.05 204.51 393.61 204.97 394.29 204.78 394.03 205.43 394.43 206.03 393.71 205.99 393.27 206.55 393.09 205.86 392.43 205.61 393.02 205.23 393.05 204.51",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.41 198.09 378.29 198.14 378.84 197.46 379.06 198.31 379.87 198.61 379.14 199.08 379.1 199.96 378.43 199.4 377.58 199.64 377.9 198.82 377.41 198.09",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.85 189.99 414.72 190.05 415.26 189.35 415.48 190.2 416.3 190.51 415.56 190.97 415.52 191.86 414.86 191.3 414.01 191.53 414.32 190.72 413.85 189.99",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.09 189.42 393.65 189.45 394.01 189.01 394.14 189.56 394.67 189.75 394.2 190.05 394.17 190.61 393.75 190.25 393.2 190.4 393.41 189.88 393.09 189.42",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.07,190.61s-4.78-.11-10.67-.36-10.65-.5-10.65-.56,4.77.1,10.67.36S415.07,190.55,415.07,190.61Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.44,185.67H278.72c-1.85-4.21-2.3-8.17,0-11.78H420.44A13.66,13.66,0,0,1,420.44,185.67Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.09,
    y: 177.25,
    width: 76.76,
    height: 4.29,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.18,185.74a4.18,4.18,0,0,1-1.11-1.36,10.36,10.36,0,0,1-.75-8.53,4,4,0,0,1,.86-1.6,16.8,16.8,0,0,1-.51,1.71,11.9,11.9,0,0,0,.72,8.26A12.89,12.89,0,0,1,284.18,185.74Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.25,185.74a4.09,4.09,0,0,1-1.12-1.36,10.4,10.4,0,0,1-.75-8.53,4.21,4.21,0,0,1,.86-1.6,14.55,14.55,0,0,1-.5,1.71,11.9,11.9,0,0,0,.72,8.26A12.89,12.89,0,0,1,287.25,185.74Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.71,185.47a25.08,25.08,0,0,0,1-5.77,24.56,24.56,0,0,0-.93-5.77A12,12,0,0,1,414.71,185.47Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.06,185.44c-.15,0,.45-2.52.44-5.65s-.6-5.6-.45-5.65a17.36,17.36,0,0,1,0,11.3Z",
    fill: "#f5f5f5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.46,575.56s-32.07,8.58-28.24,39.22c0,0-5.64,26.48,17.26,22.21l23-56.68Z",
    fill: "#e6e7e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M321.59,491.65,377,500.54l54.27-16.49,83.41-9.4s61.56-18.9,74.21-16.64a76.72,76.72,0,0,1-22.43,26s-114.85,76-116.66,75.17-54.7-21.43-81.77-37C368,522.23,333.48,496.12,321.59,491.65Z",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M321.59,491.65,377,500.54l54.27-16.49,83.41-9.4s61.56-18.9,74.21-16.64a76.72,76.72,0,0,1-22.43,26s-114.85,76-116.66,75.17-54.7-21.43-81.77-37C368,522.23,333.48,496.12,321.59,491.65Z",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M480.5,277.34s39.88-13,46,28l3.07,70.95,4.22,45.26-33.48,29s-8.69-7.71-.21-50.87C500.12,399.72,510.09,314.37,480.5,277.34Z",
    fill: "#7d00f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M480.5,277.34s39.88-13,46,28l3.07,70.95,4.22,45.26-33.48,29s-8.69-7.71-.21-50.87C500.12,399.72,510.09,314.37,480.5,277.34Z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M382.06,296.44s-29.35,5.14-43.92,18.18c0,0,51.85,167.51,38.81,185.92,0,0,20.33,5.75,44.87-8.82,0,0,26.85,0,33,5.37,0,0,23.78,13.81,44.87-4.22a21.37,21.37,0,0,1,10.74-7.29s14.58,1.15,0-19.56c0,0-16.87-10.74-12.65-49.09,0,0,17.64-97.4-17.26-139.59l-15,5.07-3.45,11.41Z",
    fill: "#7d00f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M460.17,285c-1,13.3-6.9,17.9-6.9,17.9-17.7,18.23-37.26,13.47-47.44,9a29.16,29.16,0,0,1-12.38-10.24c-6-8.95-.78-11.76-.78-11.76a16.66,16.66,0,0,0,1.92-2.44c9.29-14.24,4.38-47.72,4.23-48.73,6.4,16.94,19.36,28.53,34.31,28.53a29.33,29.33,0,0,0,12.23-2.7c.33,17,5.28,20,10.22,20.65h0A13.74,13.74,0,0,0,460.17,285Z",
    fill: "#f9b499"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M398.82,238.66a124,124,0,0,1,1.5,19s12.29,18.58,39.85,8.69Z",
    fill: "#f7a48b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M471.68,214.74c0,23.17-11,42.82-26.32,49.78a29.33,29.33,0,0,1-12.23,2.7c-14.95,0-27.92-11.6-34.31-28.55h0a68,68,0,0,1-4.23-23.92c0-29,17.26-52.46,38.54-52.46S471.68,185.77,471.68,214.74Z",
    fill: "#f9b499"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M430.83,324.12s-35.53,7.41-48.14-23.77a8.44,8.44,0,0,1-.63-3.91,4.37,4.37,0,0,1,2.18-3.76l10.35-5.26a16.66,16.66,0,0,1-1.92,2.44s-5.26,2.81.78,11.76a29.16,29.16,0,0,0,12.38,10.24c10.18,4.51,29.74,9.27,47.44-9,0,0,5.88-4.6,6.9-17.9,0,0-1.73-2.3,2.3-2.3,0,0,4.22-1.34,4.8,1.73C467.27,284.43,472.44,319.33,430.83,324.12Z",
    fill: "#7d00f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M430.83,324.12s-35.53,7.41-48.14-23.77a8.44,8.44,0,0,1-.63-3.91,4.37,4.37,0,0,1,2.18-3.76l10.35-5.26a16.66,16.66,0,0,1-1.92,2.44s-5.26,2.81.78,11.76a29.16,29.16,0,0,0,12.38,10.24c10.18,4.51,29.74,9.27,47.44-9,0,0,5.88-4.6,6.9-17.9,0,0-1.73-2.3,2.3-2.3,0,0,4.22-1.34,4.8,1.73C467.27,284.43,472.44,319.33,430.83,324.12Z",
    fill: "#fff",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M498.93,447.38s5-16.26,22.22-22.78c0,0,16.11-9.58,16.88,5,0,0,8.43,1.92,3.45,11.89,0,0-24.47-5.83-33.14,22.78A39.82,39.82,0,0,1,498.93,447.38Z",
    fill: "#7d00f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M498.93,447.38s5-16.26,22.22-22.78c0,0,16.11-9.58,16.88,5,0,0,8.43,1.92,3.45,11.89,0,0-24.47-5.83-33.14,22.78A39.82,39.82,0,0,1,498.93,447.38Z",
    opacity: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M341.92,315a4.68,4.68,0,0,0-4.91.2c-7.71,5.14-30.6,25-9.92,69.93,0,0,46.79,115.44,65.2,112l8.44-56.38a328.13,328.13,0,0,1-26.47-59.83S361.57,326.22,341.92,315Z",
    fill: "#7d00f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M341.92,315a4.68,4.68,0,0,0-4.91.2c-7.71,5.14-30.6,25-9.92,69.93,0,0,46.79,115.44,65.2,112l8.44-56.38a328.13,328.13,0,0,1-26.47-59.83S361.57,326.22,341.92,315Z",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M424.75,483.07s-2.26,7.72-7,10.91l-5.51-5S420,487.67,424.75,483.07Z",
    fill: "#7d00f2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M424.75,483.07a15.73,15.73,0,0,1-7,10.91l-5.51-5S420,487.67,424.75,483.07Z",
    opacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M414.53,440.71s15.73-11.5,47.56-46.79c0,0-6.9-45.25,7.67-50.62,0,0,21.86-15.73,25.31,0,0,0,5.81,1.53,3.86,8.44,0,0,8.28,2.31,3.36,9.21,0,0,12.73,15.71-8.75,19.17,0,0,3.45,16.4-9.59,25.65,0,0-41,66.39-66.35,82.88C417.6,488.65,403.56,458.56,414.53,440.71Z",
    fill: "#f9b499"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M418.49,437.52s-1.4,19,8.84,31.54a3.61,3.61,0,0,0,5.53.07l40.91-47.62s-34.69,53.65-56.17,67.14c0,0-17.23-22.82-3.07-47.94Z",
    fill: "#f7a48b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M473.33,341,421.9,261.16a4.47,4.47,0,0,1,1.63-6.26h0a4.47,4.47,0,0,1,6,1.55l52.29,80.74S479,337.8,473.33,341Z",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M478.84,332.65s2.62-11.77,6.63-9.43c0,0,4.73.3,3.4,13.26a14.93,14.93,0,0,0-7.09.71Z",
    fill: "#f7a48b"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 476.12,
    y1: 349.59,
    x2: 495.07,
    y2: 343.3,
    fill: "none",
    stroke: "#f7a48b",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 481.78,
    y1: 356.6,
    x2: 498.93,
    y2: 351.74,
    fill: "none",
    stroke: "#f7a48b",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 487.14,
    y1: 364.95,
    x2: 502.29,
    y2: 360.95,
    fill: "none",
    stroke: "#f7a48b",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M493.54,380.12s-3.73-3.82,8-7.49",
    fill: "none",
    stroke: "#f7a48b",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M370,258.69s-2.2,5.78-11.42-4.35c0,0-20.19-40.86,11.42-88.28,0,0,29.85-47.41,72-17.12,0,0,22.82-10.53,35.12,20.2a103,103,0,0,1,4.63,34.68s-2,8.2,3.27,19.24c0,0,11.41,22.46-7.46,34.76,0,0,4.45-8.09,4.35-13.83a3.75,3.75,0,0,0-1.38-2.92c-1-.8-2.45-.9-3,3.58,0,0,1.71,15.5-17.42,22.57,0,0-3.13,7.16-8.66,8.15,0,0-2.42,6-4.8.7a49.48,49.48,0,0,1-1.35-11.55,48.25,48.25,0,0,0,15.78-13.68c7.27-10.16,13.3-27,8.35-53.56,0,0-8.59,5.22-11.22-3.12,0,0-7.9,4.83-11.42-.88,0,0-10.31,7.46-13.71,2.2,0,0-12.63,4.83-20.53,3.07,0,0-10.63-.41-14,12.49,0,0-7.15,14,.24,27.65,0,0,3.72,26.82-.37,39a20.14,20.14,0,0,0-8.51-10,2.21,2.21,0,0,0-1.81-.18C385.94,268.34,379.28,269.37,370,258.69Z",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M376.57,521.25c20.64,13.24,73.18,38,73.18,38l24,13c-9.8,8.44-15.28,44.1-15.28,44.1L377,596.42c-11.12-.77-37.5-14.19-37.5-14.19-52.84-12.66-53-53.69-53-53.69,1.34-22.25,10.74-31.55,19.8-35.29a28.17,28.17,0,0,1,24,1.42C340.78,500.32,362.21,512,376.57,521.25Z",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M588.84,458s40.08-.42,38.93,23c0,0,11.89,43.72-42.95,69,0,0-48.26,30.69-63.83,30.69l-13.84,5.75-17.83-6.14-15.55-8-9.91-21.34,102.55-66.87A80,80,0,0,0,588.84,458Z",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M449.75,559.22s-3.52-2.25-1-4.41c0,0,10.62-12.15,15.13-11.82,0,0,7,0,5.66,4.2a31.9,31.9,0,0,0-2.66,2s10.78,13.5,12.54,18.31c0,0-4.56-2.7-7.91,3.89Z",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M449.75,559.22s-3.52-2.25-1-4.41c0,0,10.62-12.15,15.13-11.82,0,0,7,0,5.66,4.2,0,0-1.89,1.28-2.66,2,0,0,10.78,13.5,12.54,18.31,0,0-4.56-2.7-7.91,3.89Z",
    fill: "#fff",
    opacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M480.78,621.14l36.11,9.49s11-2.07,10.67-35.78l-20.41-8.4-17.83-6.14S480.78,596.46,480.78,621.14Z",
    fill: "#f9b499"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M516.89,630.63s28.71,6.81,33.74,7.4c0,0-.86-18.79,3.71-21.67,0,0,10.78-7.31,2.5-8.2,0,0-6.21-1.18-5-5.62,0,0-.48-1.68-6.61-2.23a21.4,21.4,0,0,1-5.05-1.1l-12.59-4.36S528.69,625.9,516.89,630.63Z",
    fill: "#d1d3d4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M637.28,652.52s-3.55,2.37-21-2.66c0,0-3.25-1.48-19.51-.89,0,0-3.56.89-17.75-1.19,0,0-26,3.26-28.39-9.75,0,0-.83-20.8,3.71-21.67,0,0,10.78-7.61,2.5-8.2,0,0-5.78-.86-5.23-4.79a1.7,1.7,0,0,0-1-1.72c-1.09-.54-3.2-1.2-7.21-1.58,0,0,6.71-8.73,13.81-11.42h0a8.86,8.86,0,0,1,7.27,0l8.58,5.33s10.34,5,21,4.14c0,0,36.08.59,43.18,18.33C637.28,616.44,648.81,640.69,637.28,652.52Z",
    fill: "#7d00f2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M637.28,652.52c11.53-11.83,0-36.08,0-36.08-7.1-17.74-43.18-18.33-43.18-18.33-10.65.88-21-4.14-21-4.14l-8.58-5.33a8.86,8.86,0,0,0-7.27,0c.27-.28,9.18-9.3,22.91,0a44.87,44.87,0,0,0,28.55,4.7s26.76-4.12,40.41,18.06A36.33,36.33,0,0,1,654,638.16C652.38,645.51,648.11,653.11,637.28,652.52Z",
    fill: "#e6e7e8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M332.49,580.31s-27.5.64-27.82,31.6c0,0-3.19,19.47,2.87,24.57,0,0,7.66,3.2,21.06-2.87,0,0,10.86-2.76,17.24-3,0,0,38-1.8,43-7.23,0,0,.95-19.92-4.89-25.28l-7-1.7a80.86,80.86,0,0,1-19.59-6l-17.91-8.22Z",
    fill: "#7d00f2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M415.41,616.36a67.05,67.05,0,0,1-3.18-11.31l-28.32-6.93s5.08,5.49,4.89,25.28C388.8,623.4,404.56,620.5,415.41,616.36Z",
    fill: "#d1d3d4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M415.41,616.36l18.26-6.07-21.44-5.24S413.5,612.52,415.41,616.36Z",
    fill: "#f9b499"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M522.69,481l-8.83,6.14-5.52,12.27,132.47-75.17,5.37-16.11c-23.48,11.55-48.33,25-74,40.62C554.51,459.46,538,470.27,522.69,481Z",
    fill: "#7d00f2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M522.69,481l-8.83,6.14-5.52,12.27,132.47-75.17,5.37-16.11c-23.48,11.55-48.33,25-74,40.62C554.51,459.46,538,470.27,522.69,481Z",
    fill: "#fff",
    opacity: 0.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "640.81 424.22 646.18 408.11 649.22 410.01 643.88 428.06 509.65 503.14 508.34 499.39 640.81 424.22",
    fill: "#7d00f2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.52,
    cy: 223.06,
    rx: 11.51,
    ry: 17.83,
    transform: "translate(-37.56 85.46) rotate(-11.89)",
    fill: "#f9b499"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M408.4,439.18s-6.52-4.61-12.28,7.67c0,0-16.49,41.55,0,55.29,0,0,10.36,4.3,16.88-5,0,0,7.67-1.61,4.6-8.51,0,0-13-31.45-3.07-47.94C414.53,440.71,411.08,435.34,408.4,439.18Z",
    fill: "#7d00f2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M408.4,439.18s-6.52-4.61-12.28,7.67c0,0-16.49,41.55,0,55.29,0,0,10.36,4.3,16.88-5,0,0,7.67-1.61,4.6-8.51,0,0-13-31.45-3.07-47.94C414.53,440.71,411.08,435.34,408.4,439.18Z",
    opacity: 0.4
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M455.67,615.67s.09,1.72.32,3.53a4.72,4.72,0,0,0,3.87,4l17.76,3.09s3.07.77,3.26-6.9c0,0,2.88-32.21,10.17-42,0,0,1.53-2.31-3.07-4.61,0,0-13-10.86-15.8-4l-1.25,1.88,1.83,2s-7.13.31-14.27,43.59Z",
    fill: "#2f2e41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M455.67,615.67s.09,1.72.32,3.53a4.72,4.72,0,0,0,3.87,4l17.76,3.09s3.07.77,3.26-6.9c0,0,2.88-32.21,10.17-42,0,0,1.53-2.31-3.07-4.61,0,0-13-10.86-15.8-4l-1.25,1.88,1.83,2s-7.13.31-14.27,43.59Z",
    fill: "#fff",
    opacity: 0.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M541.48,441.48l18.79,5s17.26-10.73,23-9.2c0,0,8.65.29,15.2-2.13a1.37,1.37,0,0,1,1.71,1.89c-2.12,4.23-8.12,11-24.58,9.44L522.69,481l-5.8-2.3a38.79,38.79,0,0,0-8.55-14.42S515.32,435.54,541.48,441.48Z",
    fill: "#f9b499"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ac7ff1c6-6b45-4d8c-86fd-8b1ece8c0688",
    "data-name": "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.7,483.6c.12.19-2.36,1.88-6.2,4.81a145.1,145.1,0,0,0-26.81,26.35c-3,3.78-4.73,6.24-4.9,6.11s1.29-2.72,4.09-6.73a108.49,108.49,0,0,1,12.36-14.46,106.27,106.27,0,0,1,14.66-12.1C250.93,484.86,253.55,483.45,253.7,483.6Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.62,462.8c.39.09-.93,6.81-3,15s-4,14.81-4.39,14.7.94-6.81,2.95-15S248.23,462.7,248.62,462.8Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.41,461.66c-1,.44-1.28,2.89-.47,4.09a3.06,3.06,0,0,0,3.9.68,3.28,3.28,0,0,0,1.3-4.38,3.23,3.23,0,0,0-4.54-.57,3.65,3.65,0,0,0-.3.27",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,471.12c.17.36-2.25,1.81-5.45,3.24s-5.83,2.31-6,1.95,2.24-1.82,5.45-3.25S256.82,470.79,257,471.12Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.74,468.76a4.85,4.85,0,0,0-1.91,2.44,2.17,2.17,0,0,0,1.13,2.62,2.06,2.06,0,0,0,1.91-.41,4,4,0,0,0,1.09-1.69,3,3,0,0,0,.12-2.14,1.49,1.49,0,0,0-1.74-.94",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.67,480.88a2.91,2.91,0,1,1-.63,0",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.4,399.11a33.29,33.29,0,0,1,.36,4.88c.11,3.37.26,7.85.43,13.28.3,11.21.62,26.69.88,43.79s.4,32.6.45,43.82v13.27a29.49,29.49,0,0,1-.22,4.88,33.05,33.05,0,0,1-.36-4.87c-.11-3.36-.24-7.85-.42-13.27-.3-11.22-.61-26.71-.89-43.81s-.4-32.61-.4-43.81V404A31.73,31.73,0,0,1,192.4,399.11Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.22,389.77A21.61,21.61,0,1,1,191,370h0A21.63,21.63,0,0,1,214.22,389.77Z",
    fill: "#7d00f2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.79,413.15c-.22,0,0-2.42.18-6.25a35.3,35.3,0,0,0-2.21-14.54,20.19,20.19,0,0,0-9.8-10.47c-3.43-1.58-5.91-1.36-5.9-1.64s.6-.23,1.7-.23a13.39,13.39,0,0,1,4.6.94,19.85,19.85,0,0,1,10.74,10.8A32.3,32.3,0,0,1,193,406.91C192.61,410.83,192,413.18,191.79,413.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.94,383c0,.44-6.06,0-12,3.89s-8.08,9.54-8.46,9.35c-.16-.07.11-1.56,1.27-3.68a19.34,19.34,0,0,1,15.31-9.92C210.49,382.5,212,382.86,211.94,383Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.28,384.75c-.24,0-.51-1.43-1.85-3.27a9.72,9.72,0,0,0-15.15-1.25c-1.63,1.58-2.14,3-2.37,2.9s0-1.64,1.62-3.6A10.14,10.14,0,0,1,198.78,378a9.93,9.93,0,0,1,2.49,2.94C202.53,383.13,202.43,384.75,202.28,384.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.31,388.89c-.42,0-.88-2.93-2.72-6s-4.09-5-3.87-5.34,3.15,1.17,5.12,4.62S196.7,388.92,196.31,388.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.22,382.46c.09.42-1.69,1-3.17,2.44s-2.5,3.11-2.88,2.89.09-2.1,1.88-3.94S194.2,382.12,194.22,382.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.37,465.45c.38-.12,6.32,17.39,13.27,39.09s12.27,39.41,11.91,39.51-6.32-17.38-13.27-39.06S146,465.58,146.37,465.45Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,508.64c-.24.26-6.31-4.54-13.9-10.37s-13.53-10.9-13.27-11.22,6.57,4.19,14.23,10.09S160.5,508.31,160.2,508.64Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.66,485.25c-1.17,1.08-.75,3.46.58,4.79s4.38.68,5.45-.9a3.55,3.55,0,0,0-1.37-4.8,3.93,3.93,0,0,0-4.93,1.29",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,456.92c.44.08-.86,6.32-3.43,13.63s-4.09,13.31-4.53,13.24.59-6.36,3.17-13.7S159.86,456.85,160.2,456.92Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52,451.53c-1.44,1-1.51,1.64-2.06,3.33s.23,3.9,2,4.27,3.12-1.06,3.8-2.58a4.55,4.55,0,0,0,0-4.33,2.53,2.53,0,0,0-3.49-.73,1.91,1.91,0,0,0-.38.31",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.76,503.25c-.14-.36,2.41-1.78,5.71-3.17s6.09-2.22,6.25-1.87-2.38,1.8-5.69,3.19S134.91,503.62,134.76,503.25Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.54,500.84c-1,.52-1.36,2.92-1.36,3.91a3.22,3.22,0,0,0,1.52,2.47,3.86,3.86,0,1,0-.19-6.38",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,461.41a5.14,5.14,0,0,0,8.87,4.52,3.69,3.69,0,0,0,1-2.93,6,6,0,0,0-4.63-4.27,5.31,5.31,0,0,0-5.24,2.73",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,482.92c.19.08-.52,2.25-1.72,5.73l-4.75,13.54c-1.82,5-3.44,9.54-4.88,13.52-1.28,3.45-2.1,5.56-2.3,5.45s2-8.93,5.81-19.5S213.65,482.76,214,482.92Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,473a18.5,18.5,0,1,1-14.26-21.94h0A18.52,18.52,0,0,1,237,473Z",
    fill: "#7d00f2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.89,486.72c-.2-.09.59-2,1.6-5.11a30.41,30.41,0,0,0,1.69-12.44,17.28,17.28,0,0,0-5.45-10.9c-2.41-2.14-4.48-2.59-4.4-2.85s2.26,0,5,2.06A17,17,0,0,1,217.56,469,27.09,27.09,0,0,1,215.39,482C214.17,485.06,213.05,486.79,212.89,486.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.76,466.92c-.08.43-5-1.36-10.75.36s-8.94,5.83-9.24,5.52.41-1.28,1.87-2.73a16.45,16.45,0,0,1,7-4.09,16.27,16.27,0,0,1,8.08-.28C235.71,466.08,236.83,466.71,236.76,466.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.41,466c-.24,0-.13-1.36-.79-3.12a8.32,8.32,0,0,0-10.47-5.36,8.61,8.61,0,0,0-1.55.69c-1.72.87-2.5,1.89-2.73,1.74s.38-1.36,2.17-2.61a8.68,8.68,0,0,1,13.5,5.26C229,464.7,228.56,466,228.41,466Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.52,467.93c-.42-.09-.12-2.63-.86-5.58s-2.1-5.09-1.77-5.36,2.38,1.69,3.17,5S222.87,468.07,222.52,467.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.34,462.13c0,.43-1.61.52-3.13,1.36s-2.82,1.89-3.12,1.58.52-1.77,2.46-2.86S222.42,461.79,222.34,462.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.46,444.13a14.06,14.06,0,0,1,.71,3.08c.39,2.28.87,5.11,1.36,8.42,1.13,7.12,2.6,17,4.09,27.86s2.83,20.76,3.72,27.91c.38,3.34.69,6.18,1,8.49a12.71,12.71,0,0,1,.15,3.14,12.92,12.92,0,0,1-.71-3.07q-.57-3.44-1.37-8.42c-1.13-7.11-2.6-17-4.08-27.88s-2.84-20.77-3.72-27.86c-.39-3.33-.7-6.17-1-8.47A13.2,13.2,0,0,1,171.46,444.13Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.17,424.69a18.49,18.49,0,1,1-22.8-12.82,18.49,18.49,0,0,1,22.8,12.82Z",
    fill: "#7d00f2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.19,448c-.21,0-.39-2-.95-5.27A30.44,30.44,0,0,0,167,431a17.35,17.35,0,0,0-9.85-7.16c-3.12-.77-5.18-.2-5.2-.47s2-1.08,5.45-.52a16.92,16.92,0,0,1,10.83,7.36,27.06,27.06,0,0,1,4.09,12.45C172.55,446,172.37,448,172.19,448Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.15,419.41c.12.42-5.05,1.11-9.35,5.31s-5.22,9.31-5.63,9.17c-.18,0-.22-1.36.38-3.32a16.36,16.36,0,0,1,11.27-10.91C182.84,419.15,184.13,419.23,184.15,419.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.32,422.44c-.21.1-.72-1.07-2.15-2.38a8.31,8.31,0,0,0-11.76.11,9,9,0,0,0-1,1.32c-1.12,1.58-1.36,2.84-1.58,2.79s-.3-1.36.71-3.32a8.73,8.73,0,0,1,14.42-1.61C176.31,421,176.47,422.42,176.32,422.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172,426.91c-.41.11-1.36-2.27-3.34-4.55s-4.22-3.53-4.08-3.91,2.89.38,5.13,3S172.37,426.86,172,426.91Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.17,421.86c.18.39-1.2,1.2-2.17,2.63s-1.62,3-2,2.83-.36-1.8.86-3.66S169.06,421.52,169.17,421.86Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "174.1 640.88 157.3 519.76 229.56 519.76 214.82 640.88 174.1 640.88",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36,567.13c0,.32-13.55.6-30.24.6s-30.25-.28-30.25-.6,13.54-.62,30.25-.62S224.36,566.78,224.36,567.13Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.85,574.91c0,.34-13,.61-28.95.61s-28.93-.27-28.93-.61,12.95-.55,28.93-.55S222.85,574.58,222.85,574.91Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,582.36c0,.34-12.54.61-28,.61s-28-.27-28-.61,12.54-.6,28-.6S222,582,222,582.36Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,590.46c0,.34-12,.61-26.91.61s-26.93-.27-26.93-.61,12-.6,26.93-.6S221,590.13,221,590.46Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05,597.85c0,.35-11.5.62-25.68.62s-25.69-.27-25.69-.62,11.5-.61,25.69-.61S220.05,597.53,220.05,597.85Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.62,605.25c0,.33-11.08.6-24.73.6s-24.73-.27-24.73-.6,11.07-.61,24.73-.61S218.62,604.91,218.62,605.25Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.25,612.65c0,.33-10.76.6-24,.6s-24-.27-24-.6,10.75-.61,24-.61S218.25,612.31,218.25,612.65Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.35,620.05c0,.33-10.32.6-23.07.6s-23.07-.27-23.07-.6,10.33-.61,23.07-.61S217.35,619.71,217.35,620.05Z",
    fill: "#fafafa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairy);
export default __webpack_public_path__ + "static/media/Dairy.75c8c1be33386b0f0edd7200219e4dc2.svg";
export { ForwardRef as ReactComponent };